import { useState } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { toast } from "react-toastify";
import { useLocation, useNavigate, useParams } from "react-router";
import { useSelector } from "react-redux";
import { selectUser } from "../store/userSlice";

function AlertModal() {
  const { alertId } = useParams();
  const user = useSelector(selectUser);
  const [message, setMessage] = useState("");
  const navigate = useNavigate();
  const location = useLocation();
  const handleClose = () =>
    navigate({ pathname: "/alerts", search: location.search });

  const getAlert = async () => {
    let headersList = {
      Accept: "*/*",
      "Content-Type": "application/json",
    };

    let response = await fetch(`/auth/alerts/${alertId}`, {
      method: "GET",
      headers: headersList,
    });

    let data = await response.json();
    if (response.ok) {
      setMessage(data.Compiled);
    } else {
      toast.error(data.error);
      if (response.status === 401) {
        if (user) {
          toast.error("Your session has expired. You need to login again.");
        }
        navigate("/login", { state: { from: location } });
      }
    }
  };

  return (
    <Modal show onHide={handleClose} onEnter={getAlert} size="xl">
      <Modal.Body>
        <div dangerouslySetInnerHTML={{ __html: message }}></div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary btn-sm" onClick={handleClose}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default AlertModal;
